// extracted by mini-css-extract-plugin
export default {"gallery-container":"GalleryPage_gallery-container__I49xp"};